import { Location } from '@angular/common';
import * as moment from 'moment';
import { Component, OnInit } from '@angular/core';
import { MbscDatepickerOptions, MbscSelectOptions } from '@mobiscroll/angular';
import { MbscSelectOnFilterEvent } from '@mobiscroll/angular/dist/js/core/components/select/select';
import { ListFilter } from 'src/app/core/list-filter.model';
import { PDxListItem, PDxLists } from 'src/app/core/PDxListItem.model';
import { PDxPOStatus } from 'src/app/core/PDxPOStatus.enum';
import { ajaxCall, DataTablesResponse } from 'src/app/core/services/ajax-call.service';
import { OrderSummary } from '../models/order-summary.model';
import { ConfirmService } from 'src/app/core/services/confirm.service';
import { OrderDetailComponent } from '../order-detail/order-detail.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-order-management',
  templateUrl: './order-management.component.html',
  styles: [
  ]
})
export class OrderManagementComponent implements OnInit {

  showList: boolean = false;
  accounts: PDxListItem<string>[] = [];
  filterCount: number = 0;
  accountOptions: MbscSelectOptions = {
    filter: true,
    touchUi: false,
    theme: 'ios',
    themeVariant: 'light',
    onFilter: (ev: MbscSelectOnFilterEvent) => {
      var fCt = ++this.filterCount;
      this.accounts = [];
      if (ev.filterText) {
        this.ajax.MakeCall<PDxListItem<string>[]>('/Entity/DropDownList', { accountId: null, query: ev.filterText }, false).then((data) => {
          if (fCt == this.filterCount) {
            this.accounts = data;
            if (this.accounts.filter((x) => x.value == this.filter.accountId).length == 0) {
              this.filter.accountId = null;
            }
          }
        }, () => { });
      } else {
        if (this.accounts.filter((x) => x.value == this.filter.accountId).length == 0) {
          this.filter.accountId = null;
        }
      }
      return false;
    },
    onChange: (event, inst) => {
      this.hideTheList();
    },
    buttons: [{
      text: 'clear', handler: (event) => {
        this.accounts = [];
        this.entities = [];
        this.filter.accountId = null;
        this.filter.entityId = null;
        this.hideTheList();
      }
    }]
  };
  entities: PDxListItem<string>[] = [];
  parentOptions: MbscSelectOptions = {
    filter: true,
    touchUi: false,
    theme: 'ios',
    themeVariant: 'light',
    onFilter: (ev: MbscSelectOnFilterEvent) => {
      var fCt = ++this.filterCount;
      this.entities = [];
      if (!this.filter.accountId) {
        return false;
      }
      if (ev.filterText) {
        this.ajax.MakeCall<PDxListItem<string>[]>('/Entity/DropDownList', { accountId: this.filter.accountId, query: ev.filterText }, false).then((data) => {
          if (fCt == this.filterCount) {
            this.entities = data;
            //            this.validateCurrentParent();
          }
        }, () => { });
      } else {
        //        this.validateCurrentParent();
      }
      return false;
    },
    onChange: (ev: any) => {
      this.hideTheList();
    },
    buttons: [{
      text: 'clear', handler: (event) => {
        this.entities = [];
        this.filter.entityId = null;
        this.hideTheList();
      }
    }]
  };

  vendors: PDxListItem<string>[] = [];
  vendorOptions: MbscSelectOptions = {
    filter: true,
    touchUi: false,
    theme: 'ios',
    themeVariant: 'light',
    onFilter: (ev: MbscSelectOnFilterEvent) => {
      var fCt = ++this.filterCount;
      this.vendors = [];
      if (ev.filterText) {
        this.ajax.MakeCall<PDxListItem<string>[]>('/Vendor/DropDownList', { query: ev.filterText }, false).then((data) => {
          if (fCt == this.filterCount) {
            this.vendors = data;
            if (this.vendors.filter((x) => x.value == this.filter.vendorId).length == 0) {
              this.filter.vendorId = null;
            }
          }
        }, () => { });
      } else {
        if (this.vendors.filter((x) => x.value == this.filter.vendorId).length == 0) {
          this.filter.vendorId = null;
        }
      }
      return false;
    },
    onChange: (ev: any) => {
      this.hideTheList();
    },
    buttons: [{
      text: 'clear', handler: (event) => {
        this.filter.vendorId = null;
        this.hideTheList();
      }
    }]
  };

  filter: OrderListFilter;
  results: DataTablesResponse<OrderSummary>;
  pdxOrderStatusList: PDxListItem<PDxPOStatus>[] = PDxLists.PDxAdminPOStatuses();

  refToMoment = moment;
  dateOptions: MbscDatepickerOptions = {
    controls: ['calendar'],
    select: 'range',
    theme: 'ios',
    themeVariant: 'light',
    returnFormat: 'moment',
    dateFormat: 'M/D/YYYY',
    calendarType: 'month',
    onChange: () => {
      this.hideTheList();
    }
  };

  constructor(private ajax: ajaxCall,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private modalService: NgbModal,
    private confirmService: ConfirmService) {
    this.pdxOrderStatusList.unshift({ value: null, text: 'All' });
    this.resetFilters();
  }

  ngOnInit(): void {
    this.resetFilters();
    this.showTheList();
    if (this.route.snapshot.params.orderId) {
      this.viewOrderDetails(this.route.snapshot.params.orderId);
    };
  }

  hideTheList = function () {
    this.showList = false;
  }

  showTheList(): void {
    if (!this.showList) {
      this.loadList(true);
    }
  }

  resetFilters(): void {
    this.filter = new OrderListFilter(10, 'PO #', 'desc');
    this.filter.status = this.pdxOrderStatusList[0];
    this.filter.dateRange = [];
    this.hideTheList();
  }

  loadList = (reset: boolean = false) => {
    if (reset) {
      this.filter.page = 1;
    }
    if (this.filter.dateRange) {
      if ((this.filter.dateRange.length > 0) && (this.filter.dateRange[0])) {
        this.filter.startDate = this.filter.dateRange[0].startOf('day').utc().valueOf();
      } else {
        this.filter.startDate = null;
      }
      if ((this.filter.dateRange.length > 1) && (this.filter.dateRange[1])) {
        this.filter.endDate = this.filter.dateRange[1].endOf('day').utc().valueOf();
      } else {
        this.filter.endDate = null;
      }
    }
    this.ajax.MakeCall<DataTablesResponse<OrderSummary>>('/Order/FullAdminList', this.filter).then(results => {
      this.results = results;
      this.showList = true;
    }, () => { console.log('error'); });
  }

  downloadPDF(orderId: string): void {
    window.open('/OrderPDF/' + orderId);
  }

  retransmit(orderId: string): void {
    this.confirmService.confirm('Retransmit Order', 'Are you sure that you want to retransmit this order?').then(() => {
      this.ajax.MakeCall('/Order/Retransmit', { orderId: orderId }).then(() => {
        this.loadList();
      }, () => { });
    }, () => { });
  }

  deleteOrder(orderId: string): void {
    this.confirmService.delete('Delete Order', 'Are you sure that you want to delete this order?').then(() => {
      this.ajax.MakeCall('/Order/Delete', { orderId: orderId }).then(() => {
        this.loadList();
      }, () => { });
    }, () => { });

  }

  viewOrder(orderId: string): void {
    this.viewOrderDetails(orderId);
  }

  viewOrderDetails(orderId: string): void {
    const modal = this.modalService.open(OrderDetailComponent, { size: 'xl', backdrop: 'static', keyboard: false });
    modal.componentInstance.orderId = orderId;
    modal.result.then(() => {
      this.loadList(false);
    }, () => { })
      .finally(() => {
        var url = this.router.createUrlTree(['/manage', 'orders']).toString();
        this.location.go(url);
      });
  }

  selectStatus(s: PDxListItem<PDxPOStatus>): void {
    this.filter.status = s;
    this.hideTheList();
  }

  clearError(orderId: string): void {
    this.confirmService.yesNoCancel('Clear Error', 'Do you want to retransmit this order after clearing the error?').then((transmit) => {
      this.ajax.MakeCall('/Order/Clear', { orderId: orderId, transmit: transmit }).then(() => {
        this.loadList(false);
      }, () => { });
    }, () => { })
  }
}

class OrderListFilter extends ListFilter {
  accountId: string;
  entityId: string;
  vendorId: string;
  dateRange: moment.Moment[];
  startDate: number;
  endDate: number;
  status: PDxListItem<PDxPOStatus>;
  poNumber: number;
}